import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M9 7h6v10H9z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M15 7v10H9V7h6zm6-2h-3v14h3V5zm-4 0H7v14h10V5zM6 5H3v14h3V5z"
}, "1")], 'ViewArrayTwoTone');